/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Tawk_Property_IdInputs */

const en_admin_settings_fields_tawk_property_id = /** @type {(inputs: Admin_Settings_Fields_Tawk_Property_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property ID`)
};

/**
* | output |
* | --- |
* | "Property ID" |
*
* @param {Admin_Settings_Fields_Tawk_Property_IdInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_tawk_property_id = /** @type {((inputs?: Admin_Settings_Fields_Tawk_Property_IdInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Tawk_Property_IdInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_tawk_property_id(inputs)
});
export { admin_settings_fields_tawk_property_id as "admin.settings.fields.tawk_property_id" }